var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-3 py-3 mt-5"},[_c('h1',[_vm._v("ADMIN")])])}
var staticRenderFns = []

export { render, staticRenderFns }